import { AbsoluteFill, useCurrentFrame, useVideoConfig, interpolate, spring } from "remotion";
import React from "react";

// VFX: Stats Trio Cards
// Category: ui-elements · Tags: stats, cards, trio, metrics, counter
export default function CardStatsTrioCounterCards1200Ms() {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();
  const cards = [
    { value: 12500, label: "Views", suffix: "", color: "#06b6d4" },
    { value: 89, label: "Engajamento", suffix: "%", color: "#a855f7" },
    { value: 340, label: "Novos seguidores", suffix: "", color: "#10b981" },
  ];
  return (
    <AbsoluteFill style={{ background: "#0a0e1a", justifyContent: "center", alignItems: "center", padding: 60, gap: 32 }}>
      {cards.map((c, i) => {
        const delay = i * 6;
        const enter = spring({ frame: frame - delay, fps, config: { damping: 12, mass: 0.6 } });
        const count = spring({ frame: frame - delay - 4, fps, config: { damping: 22, mass: 1.2 } });
        const value = Math.round(count * c.value);
        return (
          <div key={i} style={{
            width: "100%", maxWidth: 720,
            background: "linear-gradient(135deg, #1e293b, #0f172a)",
            borderRadius: 24, padding: 36,
            border: `1px solid ${c.color}40`,
            display: "flex", justifyContent: "space-between", alignItems: "center",
            opacity: enter,
            transform: `translateY(${interpolate(enter, [0, 1], [40, 0])}px) scale(${interpolate(enter, [0, 1], [0.92, 1])})`,
            boxShadow: `0 12px 40px ${c.color}25`,
          }}>
            <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
              <span style={{ color: "#94a3b8", fontFamily: "Inter", fontSize: 24, letterSpacing: 3, textTransform: "uppercase" }}>{c.label}</span>
              <span style={{ color: "#f8fafc", fontFamily: "Inter", fontSize: 84, fontWeight: 900, letterSpacing: -2, fontVariantNumeric: "tabular-nums" }}>
                {value.toLocaleString("pt-BR")}{c.suffix}
              </span>
            </div>
            <div style={{ width: 16, height: 80, borderRadius: 8, background: c.color, boxShadow: `0 0 24px ${c.color}` }} />
          </div>
        );
      })}
    </AbsoluteFill>
  );
}

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
